<template>
    <div>
        <export-excel
            class="btn btn-outline-success"
            :data="data"
            :name="name"
        >
            <feather-icon
                size="21"
                icon="DownloadIcon"
            />
            
            {{ buttonText }}
        </export-excel>
    </div>
</template>

<script>

    import ExportExcel from 'vue-excel-export';

    export default {
        components: {
            ExportExcel
        },
        props: {
            buttonText: {
                type: String,
                default: "EXPORTAR EXCEL"
            },
            name: {},
            data: {}
        }
    }

</script>

<style scoped>

    .btn {
        display: block;
        width: 100%;
        margin-bottom: 1rem !important;
        border-radius: 0.25rem !important;
        font-weight: bold;
    }

    .btn.btn-outline-success {
        cursor: pointer;
    }

    .btn svg {
        margin-right: .5rem !important;
    }

</style>
